module.exports = __webpack_public_path__ + "img/dermatology.91289fb4.svg";